import { PrimaryButton } from '@/components/PrimaryButton';
import { ArrowUpward } from '@/components/icons/ArrowUpward';
import { Anchor, Button, Flex, Group, Text } from '@mantine/core';
import { PartnershipConfig } from './legacyConfig';

interface Props {
  config: PartnershipConfig;
  isPartnershipPreset: boolean;
  isLessThan5k: boolean;
  isLoading: boolean;
  onPrimary: () => void;
  onRejected: () => void;
}

export const LegacyActions = ({
  config,
  isPartnershipPreset,
  isLessThan5k,
  isLoading,
  onPrimary,
  onRejected,
}: Props) => (
  <Flex
    w="100%"
    justify="center"
    align="center"
    mx="auto"
    mt={25}
    direction="column"
  >
    <Anchor
      href={config.content.ezFileLink}
      target="_blank"
      fz="sm"
      maw={343}
      w="100%"
    >
      <PrimaryButton
        loading={isLoading}
        type="button"
        onClick={onPrimary}
        w="100%"
        mt={{ base: 12, md: 0 }}
        {...config.content.primaryButtonStyles}
      >
        {config.content.primaryButtonText}
      </PrimaryButton>
    </Anchor>

    <Button
      type="button"
      onClick={onRejected}
      mt={20}
      ml={10}
      mr={10}
      loading={isLoading}
      w={{ base: '100%', xs: 200, sm: '100%', md: '100%' }}
      sx={{
        root: {
          backgroundColor: 'transparent',
          border: 'none',
        },
      }}
      p={0}
    >
      <Group spacing={2}>
        <Flex
          align="center"
          justify="center"
          wrap="wrap"
        >
          <Text
            mr={4}
            fw={700}
            c="neutral.6"
            align="center"
            style={{
              whiteSpace: 'break-spaces' as const,
            }}
          >
            I&apos;ve already been rejected for financial aid
          </Text>
          <ArrowUpward color={config.content.rejectedButtonArrowColor} />
        </Flex>
      </Group>
    </Button>

    {/* Partnership-specific disclaimer */}
    {isPartnershipPreset && !isLessThan5k && (
      <Text
        size={13}
        c="primary.2"
        display="flex"
        fs="italic"
        mt={32}
      >
        <Text
          size={13}
          c="primary.2"
          fw={700}
          display="contents"
          ml={4}
        >
          EZ File&nbsp;
        </Text>
        will require you to disclose certain assets in order to determine eligibility. If
        you&apos;re unwilling to disclose your financial details to aid providers, you should
        continue with&nbsp;
        <Text
          size={13}
          c="primary.2"
          fw={700}
          display="contents"
          ml={4}
        >
          Resolve Concierge.
        </Text>
      </Text>
    )}
  </Flex>
);
